import { IconButtonProps, Popover, PopoverProps } from "@material-ui/core";
import React, { MouseEvent } from "react";

import TooltipIconButton from "./TooltipIconButton";

interface Props {
  children: React.ReactNode;
  closeOnClick?: boolean;
  icon: React.ElementType;
  PopoverProps?: Omit<PopoverProps, "open" | "onClose">;
  testId?: string;
  tooltip: string;
}

const PopoverIconButton: React.FunctionComponent<
  Props &
    Pick<PopoverProps, "anchorOrigin" | "transformOrigin"> &
    IconButtonProps
> = ({
  anchorOrigin,
  children,
  closeOnClick,
  icon: Icon,
  tooltip,
  transformOrigin,
  testId = "",
  PopoverProps,
  ...other
}) => {
  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const anchorEl = React.useRef<HTMLAnchorElement>(null);

  return (
    <>
      <TooltipIconButton
        data-testid={`PopoverIconButton-tooltipIconButton-${testId}`}
        {...other}
        buttonRef={anchorEl}
        onClick={() => setPopoverOpen(!popoverOpen)}
        tooltip={tooltip}
      >
        <Icon />
      </TooltipIconButton>
      <Popover
        data-testid={`PopoverIconButton-popover-${testId}`}
        open={popoverOpen}
        anchorEl={anchorEl.current}
        onClose={(e: MouseEvent<Node>) => {
          if (!anchorEl?.current?.contains(e.target as Node)) {
            setPopoverOpen(false);
          }
        }}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClick={closeOnClick ? () => setPopoverOpen(false) : undefined}
        {...PopoverProps}
      >
        {children}
      </Popover>
    </>
  );
};

export default PopoverIconButton;
